import React from "react";
import SelectField from "../Input_all_fields.jsx/SelectField";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import TextField from "../Input_all_fields.jsx/TextField";
import UseAxios from "../Cust_Hook/UseAxios";
import { useNavigate } from "react-router-dom";

const Inputs = () => {
  const { res, err, loading } = UseAxios({ url: "/api_category.php" });
  const navigate = useNavigate();

  if (loading) {
    return (
      <Box mt={20} mb={20} textAlign="center">
        <CircularProgress />
      </Box>
    );
  }
  if (err) {
    return (
      <Typography variant="h4" mt={20} color="red" mb={20} textAlign="center">
        Some Went Wrong
      </Typography>
    );
  }

  const difficultyOption = [
    { id: "easy", name: "Easy" },
    { id: "medium", name: "Medium" },
    { id: "hard", name: "Hard" },
  ];

  const typeOption = [
    { id: "multiple", name: "Multiple" },
  ];
  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/Ques_box");
  };
  
  return (
    <Container maxWidth="sm">
      <Box textAlign="center">
        <Typography variant="h4">Customize Your Quiz</Typography>
      </Box>
      <form onSubmit={handleSubmit}>
        <SelectField option={res.trivia_categories} label="Category" />
        <SelectField option={difficultyOption} label="Difficulty" />
        <SelectField option={typeOption} label="Type" />
        <TextField label="Amount of Question" />
        <Box mt={3} mb={3} width="100%">
          <Button fullWidth variant="contained" type="submit">
            Start Quiz
          </Button>
        </Box>
      </form>
    </Container>
  );
};

export default Inputs;
